/** Preserve DECIMAL(19,4) precision through multipart submission. */
export function normalizeLowStockThreshold(value: unknown): string | undefined {
  if (value === undefined) return undefined;
  const threshold = value === null ? "" : String(value).trim();
  if (threshold === "") return "0";
  if (!/^\d{1,15}(?:\.\d{1,4})?$/.test(threshold)) {
    throw new Error(
      "Low stock threshold must be a nonnegative number with at most 15 whole digits and 4 decimal places."
    );
  }
  return threshold;
}
